import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUserRole } from './auth';

const ProtectedRoute = ({ children, allowedRoles }) => {
    if (!isAuthenticated()) {
        // Si no está autenticado, redirige al login
        return <Navigate to="/" />;
    }

    const userRole = getUserRole();
    if (!allowedRoles.includes(userRole)) {
        return <Navigate to="/" />;
    }

    return children;
};

export default ProtectedRoute;
